// Simple helper to broadcast and subscribe to queue updates across tabs and within the same page.
// It uses both localStorage (for cross-tab) and window CustomEvent (for same-tab listeners).
export function sendQueueUpdate(detail?: any) {
  try {
    // writing a different value each time ensures storage event fires in other tabs
    localStorage.setItem('queueUpdated', Date.now().toString());
  } catch (err) {
    // ignore (some contexts disable storage)
  }

  try {
    window.dispatchEvent(new CustomEvent('queueUpdated', { detail }));
  } catch (err) {
    // fallback: dispatch a plain Event
    try { window.dispatchEvent(new Event('queueUpdated')); } catch (e) {}
  }
}

export function subscribeQueueUpdate(callback: (detail?: any) => void) {
  const storageHandler = (e: StorageEvent) => {
    if (e.key === 'queueUpdated') {
      callback(undefined);
    }
  };

  const customHandler = (e: Event) => {
    try {
      const d = (e as CustomEvent).detail;
      callback(d);
    } catch (err) {
      callback(undefined);
    }
  };

  window.addEventListener('storage', storageHandler);
  window.addEventListener('queueUpdated', customHandler as EventListener);

  return () => {
    window.removeEventListener('storage', storageHandler);
    window.removeEventListener('queueUpdated', customHandler as EventListener);
  };
}

export default { sendQueueUpdate, subscribeQueueUpdate };
